import { normalizePhoneNumber } from '@markku/utils'
import { customType } from 'drizzle-orm/pg-core'

/**
 * Custom PostgreSQL tstzrange type for Drizzle ORM
 * This type represents a timestamp with timezone range
 */
export const tstzrange = customType<{
  data: string | null
  driverData: string
}>({
  dataType() {
    return 'tstzrange'
  },
  toDriver(value: string | null): string {
    return value ?? ''
  },
  fromDriver(value: string): string | null {
    return value || null
  },
})

/**
 * Phone number column that normalizes to E.164 on every write through Drizzle.
 *
 * Any `db.insert(...).values({ phoneNumber })` or `db.update(...).set({ phoneNumber })`
 * runs the value through `normalizePhoneNumber`, so the DB only ever stores the
 * canonical form ('+358405826303'). Callers can stop normalizing manually.
 *
 * Null is passed through unchanged (Drizzle skips `toDriver` for null). An
 * empty string normalizes to null and is bound as SQL NULL.
 *
 * Bypasses: raw SQL via `ctx.db.execute(sql\`...\`)` does not go through this
 * — if that ever matters, add a Postgres trigger.
 */
export const phoneNumberColumn = customType<{
  data: string
  driverData: string | null
}>({
  dataType() {
    return 'text'
  },
  toDriver(value: string): string | null {
    return normalizePhoneNumber(value)
  },
})
